import { useTranslation } from "react-i18next";
import { Col, Row } from "reactstrap";
import { SentBarcodeDto } from "../../generated/tsClient";
import EditOutlinedIcon from '@mui/icons-material/EditOutlined'
import { Button, styled } from "@mui/material";
import { setSelectedBarcodeSending, setShowSentBarcodesModal, setShowSettingsModal } from "../../store/slices/appSlice";
import { useAppDispatch, useAppSelector } from "../../store/hooks";

function BarcodeSending(props: any) {
    const { t } = useTranslation('texts');
    const dispatch = useAppDispatch();
    const canOrderPregCheck = useAppSelector((state) => state.app.herdCanOrderPregCheck);
    const showPregCheckMessage = useAppSelector((state) => state.app.showPregCheckMessage);//NALI-284: Arla cannot edit pregnancy check orders
    const sending: SentBarcodeDto = props.sending;

    const SmallIconButton = styled(Button)({
        maxHeight: '30px',
        maxWidth: '30px',
        marginBottom: '5px',
        minHeight: '30px',
        minWidth: '30px',
        padding: '5px',
    })

    const openSentBarcodesModal = () => {
        dispatch(setSelectedBarcodeSending(sending));
        dispatch(setShowSentBarcodesModal(true));
        dispatch(setShowSettingsModal(false));
    };

    return (
        <Row>
            <Col xs='4'>
                <span className='bold'>{new Date(sending.testMilkDate).toLocaleDateString('fi-FI', { year: 'numeric', month: '2-digit', day: '2-digit' }) + ': '} </span>
            </Col>
            <Col>
                {
                    sending.barcodeCount + ' ' + t('Menu.Barcodes') + ((sending.pregCheckOrderCount != null && sending.pregCheckOrderCount > 0) ? ', ' + sending.pregCheckOrderCount + '\u00A0' + t('Menu.PregnancyTests') : '')
                }
            </Col>
            {
                canOrderPregCheck && !showPregCheckMessage && sending.animals != null && sending.animals.length > 0 && (
            <Col xs='2'><SmallIconButton
                className="btn-primary"
                fullWidth={true}
                onClick={openSentBarcodesModal }
                size="small"
                variant="contained"
            ><EditOutlinedIcon /></SmallIconButton></Col>
                )
            }
        </Row>
    );
}

export default BarcodeSending;